export const localeCodes = ["ka","en","ru"]

export const localeMessages = {
  "ka": [{ key: "../lang/ka.ts", load: () => import("../lang/ka.ts?hash=8893420c&locale=ka" /* webpackChunkName: "lang_lang_lang_ka_ts" */) }],
  "en": [{ key: "../lang/en.ts", load: () => import("../lang/en.ts?hash=8c0ed1e6&locale=en" /* webpackChunkName: "lang_lang_lang_en_ts" */) }],
  "ru": [{ key: "../lang/ru.ts", load: () => import("../lang/ru.ts?hash=d461ead7&locale=ru" /* webpackChunkName: "lang_lang_lang_ru_ts" */) }],
}

export const resolveNuxtI18nOptions = async (context) => {
  const nuxtI18nOptions = Object({})
  nuxtI18nOptions.experimental = Object({"jsTsFormatResource":true})
  nuxtI18nOptions.bundle = Object({"compositionOnly":true})
  nuxtI18nOptions.compilation = Object({"jit":true,"strictMessage":true,"escapeHtml":false})
 const vueI18nConfigLoader = async (loader) => {
            const config = await loader().then(r => r.default || r)
            return typeof config === 'object'
              ? config
              : typeof config === 'function'
                ? await config()
                : {}
          }
  const vueI18n = await vueI18nConfigLoader((() => import("../i18n.config.ts?hash=c9945f5b&config=1" /* webpackChunkName: "i18n_config_c9945f5b" */)))
  nuxtI18nOptions.vueI18n = vueI18n
  nuxtI18nOptions.vueI18n.messages ??= {}
  nuxtI18nOptions.locales = [Object({"code":"ka","iso":"ka-KA","files":["lang/ka.ts"],"hashes":["8893420c"],"types":["dynamic"]}),Object({"code":"en","iso":"en-EN","files":["lang/en.ts"],"hashes":["8c0ed1e6"],"types":["dynamic"]}),Object({"code":"ru","iso":"ru-RU","files":["lang/ru.ts"],"hashes":["d461ead7"],"types":["dynamic"]})]
  nuxtI18nOptions.defaultLocale = "en"
  nuxtI18nOptions.defaultDirection = "ltr"
  nuxtI18nOptions.routesNameSeparator = "___"
  nuxtI18nOptions.trailingSlash = false
  nuxtI18nOptions.defaultLocaleRouteNameSuffix = "default"
  nuxtI18nOptions.strategy = "prefix_except_default"
  nuxtI18nOptions.lazy = true
  nuxtI18nOptions.langDir = "lang"
  nuxtI18nOptions.rootRedirect = null
  nuxtI18nOptions.detectBrowserLanguage = false
  nuxtI18nOptions.differentDomains = false
  nuxtI18nOptions.baseUrl = ""
  nuxtI18nOptions.dynamicRouteParams = false
  nuxtI18nOptions.customRoutes = "page"
  nuxtI18nOptions.pages = Object({})
  nuxtI18nOptions.skipSettingLocaleOnNavigate = false
  nuxtI18nOptions.types = "composition"
  nuxtI18nOptions.debug = false
  nuxtI18nOptions.parallelPlugin = false
  nuxtI18nOptions.i18nModules = []
  return nuxtI18nOptions
}

export const nuxtI18nOptionsDefault = Object({experimental: Object({"jsTsFormatResource":false}),bundle: Object({"compositionOnly":true}),compilation: Object({"jit":true,"strictMessage":true,"escapeHtml":false}),vueI18n: "",locales: [],defaultLocale: "",defaultDirection: "ltr",routesNameSeparator: "___",trailingSlash: false,defaultLocaleRouteNameSuffix: "default",strategy: "prefix_except_default",lazy: false,langDir: null,rootRedirect: null,detectBrowserLanguage: Object({"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true}),differentDomains: false,baseUrl: "",dynamicRouteParams: false,customRoutes: "page",pages: Object({}),skipSettingLocaleOnNavigate: false,types: "composition",debug: false,parallelPlugin: false})

export const nuxtI18nInternalOptions = Object({__normalizedLocales: [Object({"code":"ka","iso":"ka-KA","files":["lang/ka.ts"],"hashes":["8893420c"],"types":["dynamic"]}),Object({"code":"en","iso":"en-EN","files":["lang/en.ts"],"hashes":["8c0ed1e6"],"types":["dynamic"]}),Object({"code":"ru","iso":"ru-RU","files":["lang/ru.ts"],"hashes":["d461ead7"],"types":["dynamic"]})]})
export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const isSSG = false
export const parallelPlugin = false
